import { UPDATE_APP, UPDATE_RANGE, CLEAR_FILTER } from "./actionTypes";
import moment from "moment";

const initialState = {
  app: {
    name: "",
    environment: "Live",
    platform: null,
    apiKey: null,
  },
  range: {
    // from: "2021-01-21",
    // to: "2021-01-27",
    // from: "2016-10-21",
    // to: "2016-10-27",
    from: moment().subtract(7, "days").format("YYYY-MM-DD"),
    to: moment().format("YYYY-MM-DD"),
  },
};

const reducer = function (state = initialState, action) {
  switch (action.type) {
    case UPDATE_APP:
      return { ...state, app: action.payload };
    case UPDATE_RANGE: {
      return { ...state, range: action.payload };
    }
    case CLEAR_FILTER: {
      return {
        ...state,
        range: {
          from: moment().subtract(7, "days").format("YYYY-MM-DD"),
          to: moment().format("YYYY-MM-DD"),
        },
      };
    }
    default:
      return state;
  }
};

export default reducer;
